<template>
    <div>
        <div class="group-head">
            <div class="title"><span class="el-icon-data-analysis"></span> 汇总排名</div>
        </div>
        <el-row :gutter="15" v-loading="dataLoading" class="rank-box">
            <el-col :sm="12" :md="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        渠道销售
                        <router-link class="color-theme" :to="`/report/sales/channel?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="platformSalesRankList.length > 0" class="rank">
                        <div class="item">
                            <el-image class="logo">
                                <div slot="error" class="image-slot color-danger">
                                    <span class="el-icon-money"></span>
                                </div>
                            </el-image>
                            <div class="info color-danger">
                                <div class="name">全网</div>
                                <div class="amount">销售额：{{ platformSalesRankList.find(v => v.name == '全网') && platformSalesRankList.find(v => v.name == '全网').amount || 0}}</div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo1.png"/>
                            <div class="info">
                                <div class="name">秀动</div>
                                <div class="amount">
                                    销售额：{{platformSalesRankList.find(v => v.name == '秀动') && platformSalesRankList.find(v => v.name == '秀动').amount || 0}}
                                    <div>销售占比：{{ platformSalesRankList.find(v => v.name == '秀动') && platformSalesRankList.find(v => v.name == '秀动').rank || '0.0%'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo6.png"/>
                            <div class="info">
                                <div class="name">大麦</div>
                                <div class="amount">
                                    销售额：{{platformSalesRankList.find(v => v.name == '大麦') && platformSalesRankList.find(v => v.name == '大麦').amount || 0}}
                                    <div>销售占比：{{ platformSalesRankList.find(v => v.name == '大麦') && platformSalesRankList.find(v => v.name == '大麦').rank || '0.0%'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo2.png"/>
                            <div class="info">
                                <div class="name">网易</div>
                                <div class="amount">
                                    销售额：{{platformSalesRankList.find(v => v.name == '网易') && platformSalesRankList.find(v => v.name == '网易').amount || 0}}
                                    <div>销售占比：{{ platformSalesRankList.find(v => v.name == '网易') && platformSalesRankList.find(v => v.name == '网易').rank || '0.0%'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <img class="logo" src="@/assets/img/dashboard/d-logo4.png"/>
                            <div class="info">
                                <div class="name">腾讯</div>
                                <div class="amount">
                                    销售额：{{platformSalesRankList.find(v => v.name == '腾讯') && platformSalesRankList.find(v => v.name == '腾讯').amount || 0}}
                                    <div>销售占比：{{ platformSalesRankList.find(v => v.name == '腾讯') && platformSalesRankList.find(v => v.name == '腾讯').rank || '0.0%'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="12" :md="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        单场销售
                        <router-link class="color-theme" :to="`/report/sales/show?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data && data.activitySalesRankList" class="rank">
                        <div v-for="(item,index) in data.activitySalesRankList" :key="index" class="item">
                            <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                            <div class="info">
                                <el-tooltip class="name" :content="item.name" placement="top">
                                    <span class="ellipsis">{{item.name}}</span>
                                </el-tooltip>
                                <div class="amount">销售额: {{item.amount}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="12" :md="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        巡演销售
                        <router-link class="color-theme" :to="`/report/sales/touring?timeStartStr=${daterange[0]} 00:00:00&timeEndStr=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data && data.tourSalesRankList" class="rank">
                        <div v-for="(item,index) in data.tourSalesRankList" :key="index" class="item">
                            <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                            <div class="info">
                                <el-tooltip class="name" :content="item.name" placement="top">
                                    <span class="ellipsis">{{item.name}}</span>
                                </el-tooltip>
                                <div class="amount">销售额: {{item.amount}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="12" :md="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        城市销售
                        <router-link class="color-theme" :to="`/report/sales/city?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data && data.citySalesRankList" class="rank">
                        <div v-for="(item,index) in data.citySalesRankList" :key="index" class="item">
                            <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                            <div class="info">
                                <el-tooltip class="name" :content="item.name" placement="top">
                                    <span class="ellipsis">{{item.name}}</span>
                                </el-tooltip>
                                <div class="amount">
                                    销售额: {{item.amount}}
                                    <div>销售占比：{{ item.rank || '0.0%'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="12" :md="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        艺人销售
                        <router-link class="color-theme" :to="`/report/sales/artist?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data && data.artistSalesRankList" class="rank">
                        <div v-for="(item,index) in data.artistSalesRankList" :key="index" class="item">
                            <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                            <div class="info">
                                <el-tooltip class="name" :content="item.name" placement="top">
                                    <span class="ellipsis">{{item.name}}</span>
                                </el-tooltip>
                                <div class="amount">销售额: {{item.amount}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :sm="12" :md="8" class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        场地销售
                        <router-link class="color-theme" :to="`/report/sales/site?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <div v-if="data && data.siteSalesRankList" class="rank">
                        <div v-for="(item,index) in data.siteSalesRankList" :key="index" class="item">
                            <span class="num" :class="`top-num-${index}`">{{index + 1}}</span>
                            <div class="info">
                                <el-tooltip class="name" :content="item.name" placement="top">
                                    <span class="ellipsis">{{item.name}}</span>
                                </el-tooltip>
                                <div class="amount">销售额: {{item.amount}}</div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col class="MT15">
                <el-card shadow="never">
                    <div slot="header">
                        终端销售
                        <router-link class="color-theme" :to="`/report/sales/terminal?timeStart=${daterange[0]} 00:00:00&timeEnd=${daterange[1]} 23:59:59`">查看详情</router-link>
                    </div>
                    <el-row :gutter="15" v-if="data && data.terminalSalesRankList" class="statistics">
                        <el-col :xs="24" :sm="8" v-for="(item,index) in data.terminalSalesRankList" :key="index" class="item">
                            <img v-if="item.name == 'ios'" class="logo" src="@/assets/img/dashboard/logo_ios.png"/>
                            <img v-else-if="item.name == 'android'" class="logo" src="@/assets/img/dashboard/logo_android.png"/>
                            <img v-else-if="item.name == 'wap'" class="logo" src="@/assets/img/dashboard/logo_wapcn.png"/>
                            <img v-else class="logo" src="@/assets/img/dashboard/d-logo1.png"/>
                            <div class="info">
                                <div class="name">{{item.name || '未知'}}</div>
                                <div class="amount">
                                    销售额：{{item.amount || 0}}
                                    <div>销售占比：{{ item.rank || '0.0%'}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            data: null,
            dataLoading: false,
            platformSalesRankList: []
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        daterange(v1,v2){
            if(v2.length > 0 && v1 != v2){
                this.getData();
            }
        }
    },
    methods: {
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/salesRank2",
                method: "POST",
                data: {
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.platformSalesRankList = this.data.platformSalesRankList;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped>
.statistics{
   .item{
        margin: 10px 0;
        display: flex;
        align-items: center;
       .logo{
            width: 42px;
            height: 42px;
            margin-right: 10px;
        }
        .info{
            flex: 1;
           .name{
                font-size: 16px;
                font-weight: 700;
            }
          .amount{
                font-size: 12px;
                // margin-top: 5px;
                color: #666;
           }
        }
    }
}
</style>